<template>
  <section class="homepage-section">
    <TwinColorTitle width="410px"> Hear from our <br /><em>TourHeroes</em> </TwinColorTitle>

    <ThreeVideoCarousel
      v1="https://assets.tourhero.com/wellness_review_video_1.mp4"
      v2="https://assets.tourhero.com/wellness_review_video_3.mp4"
      v3="https://assets.tourhero.com/wellness_review_video_2.mp4"
    />
  </section>
</template>

<script setup>
import TwinColorTitle from '@/components/Theme2/TwinColorTitle.vue'
import ThreeVideoCarousel from '@/components/ThreeVideoCarousel.vue'
</script>

<style lang="scss" scoped>
section.homepage-section {
  @include main-rewrap;
  gap: 32px;
  align-items: center;
  padding-block: 64px;
  border-radius: 16px;
  background: radial-gradient(77.9% 77.9% at 50% 50%, #fff 0%, #fef9e7 100%);
  overflow: hidden;
  --progress-bar-color: #a4a4a4;
  --progress-track-color: #a4a4a433;
}
</style>
